import { useState } from "react"
import { HighPriorityNovaModalContainer } from "@nova/component-nova-modal-container"
import { ButtonPrimary, ButtonTertiary } from "@nova/component-btn"
import { Checkbox } from "@nova/component-checkbox"

export const RAPID_MODE_DONT_SHOW_KEY = "rapid-mode-modal-dont-show-again"

export interface RapidModeModalProps {
    cancel: () => void
    proceed: () => void
}

export const RapidModeModal = (props: RapidModeModalProps) => {
    const { cancel, proceed } = props
    const [isChecked, setIsChecked] = useState(false)

    return (
        <HighPriorityNovaModalContainer
            title="Process with Rapid Mode?"
            bottomBar={
                <div className="flex w-full justify-between">
                    <div
                        className="flex gap-2 cursor-pointer group"
                        onClick={() => setIsChecked(!isChecked)}
                    >
                        <Checkbox isChecked={isChecked} onClick={() => {}} />
                        <h5 className="text-gray-100 group-hover:text-gray-0">
                            Don&apos;t show again
                        </h5>
                    </div>
                    <div className="flex gap-2">
                        <ButtonTertiary onClick={cancel} title="Cancel" />
                        <ButtonPrimary
                            onClick={() => {
                                if (isChecked) {
                                    localStorage.setItem(RAPID_MODE_DONT_SHOW_KEY, "true")
                                }
                                proceed()
                            }}
                            title="Process with Rapid Mode"
                        />
                    </div>
                </div>
            }
            closeModal={cancel}
            className="opacity-90"
        >
            <div className="flex flex-col gap-[20px] max-w-[416px] pt-2">
                <span>
                    <strong>Rapid Mode is in beta.</strong> It is optimized for speed and may
                    produce varied results when processing complex datasets.
                </span>
                <span>For high-precision detection, we recommend using General Mode.</span>
            </div>
        </HighPriorityNovaModalContainer>
    )
}
